import Highcharts from "highcharts";
import { EmojiPicker, NativeRenderer, createPicker, i18n } from "picmo";
import { TraceLoggingHelpers } from "../helpers/trace-logging-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { EmojiModel } from "../models/drawing-tools/emoji.model";
import { IComponent } from "./component.interface";
import { EmojiComponent } from "./drawing-tools/Emoji/emoji.component";
import { StringHelpers } from "../helpers/string-helpers";
declare const $:any;

export class HighChartAnnotationPopupComponent implements IComponent {
    public id = StringHelpers.newGuid();

    private editNewPopupSupportedTypes = ['label', 'crooked3', 'crooked5', 'customLabel', 'segment', 'curvedLine', 'arrowSegment',
        'ray', 'arrowRay', 'infinityLine', 'arrowInfinityLine', 'horizontalLine', 'verticalLine', 'elliott3', 'elliott5', 'emoji'
        // 'verticalCounter', 'verticalLabel', 'verticalArrow'
    ];

    private editElliotSegmentsSupportedTypes: Array<ElliotSegmentModel> =
        [
            new ElliotSegmentModel('elliott3', 4),
            new ElliotSegmentModel('elliott5', 6)
        ];

    // private editVerticalSegmentsSupportedTypes: Array<string> = [
    //     'verticalCounter', 'verticalLabel', 'verticalArrow'
    // ];

    private customEmojiData: Array<EmojiModel> = [];

    private base: IChartContainer;
    private editPopupOpen = false;

    private popup: HTMLElement | null = null;
    private wrapper: HTMLElement | null = null;

    constructor(base: IChartContainer) {
        this.base = base;
        this.wrapper = this.base.chartWrapper;
        
        this.subscribeChartComponentWithHighChartPopup();
        this.subscribeAnnotationAddedOrUpdate();
        this.subscribeChartService();
        this.onResize();
        this.onBodyClick();
    }
    
    public removeAllPoups() {
        const isHighChartPopupExist = $(this.wrapper).find('.highcharts-popup').length > 0;
        if (!isHighChartPopupExist) {
            return;
        }
        
        $(this.wrapper).find('.highcharts-popup').remove();
        this.beforePopupClose();
        this.onPopupClose();
    }

    private subscribeChartService() {
        this.base.chartService.subscribeEmojiData((emojiData: Array<EmojiModel>) => {
            this.customEmojiData = emojiData;
        });
    }

    private subscribeAnnotationAddedOrUpdate() {
        this.base.tiChartSeries?.subscribeAnotationAdd(this.id, (event: any, fromCache: boolean) => {
            TraceLoggingHelpers.log('after add', event)
            if (event.target?.graphic?.element) {
                $(event.target?.graphic?.element).off('dblclick');
                $(event.target?.graphic?.element).on('dblclick', () => {
                    TraceLoggingHelpers.log('dbl click')
                    let key = event.target?.options?.langKey ?? '';
                    if (event.target?.options?.isEmoji) {
                        key = 'emoji';
                    }
                    if (this.editNewPopupSupportedTypes.some((x: string) => x == key)) {
                        $(this.wrapper).find('.highcharts-annotation-edit-button').trigger('click');
                        this.openHighChartsEdit(event.target, key);
                    }
                });

                if (!fromCache) {
                    let key = event.target?.options?.langKey ?? '';
                    if (event.target?.options?.isEmoji) {
                        key = 'emoji';
                    }
                    if (key == 'label' || key == 'customLabel' || (key == 'emoji' && event.target?.options?.emojiCreateType == 2)) {
                        this.showEditPopupCustom(event.target, key);
                    }
                }
            }
        });
        this.base.tiChartSeries?.subscribeAnotationAfterUpdate(this.id, (event: any) => {
            // TraceLoggingHelpers.log('after update', event)
            if (event.target?.graphic?.element) {
                $(event.target?.graphic?.element).off('dblclick');
                $(event.target?.graphic?.element).on('dblclick', () => {
                    TraceLoggingHelpers.log('dbl click')
                    let key = event.target?.options?.langKey ?? '';
                    if (event.target?.options?.isEmoji) {
                        key = 'emoji';
                    }
                    if (this.editNewPopupSupportedTypes.some((x: string) => x == key)) {
                        $(this.wrapper).find('.highcharts-annotation-edit-button').trigger('click');
                        this.openHighChartsEdit(event.target, key);
                    }
                });
            }
        });
    }

    private showEditPopupCustom(annotation: any, key: string) {
        const chart: any = this.base.tiChartSeries?.highStockChart;
        if (!chart) {
            return;
        }

        Highcharts.fireEvent(
            chart.navigationBindings,
            'showPopup', {
            options: chart.navigationBindings.annotationToFields(annotation),
            formType: 'annotation-edit',
            onSubmit: (data: any) => {
                try {
                    let config = {};

                    chart.navigationBindings.fieldsToOptions(
                        data.fields,
                        config
                    );
                    chart.navigationBindings.deselectAnnotation();

                    TraceLoggingHelpers.log('config ', config)
                    annotation.update(config);
                } catch { }

                this.beforePopupClose();
                $(this.wrapper).find('.highcharts-popup-bottom-row button').trigger('click');
                this.onPopupClose();
                this.setAnnotationStyles();
            }
        }
        )

        this.openHighChartsEdit(annotation, key);
    }

    private subscribeChartComponentWithHighChartPopup() {
        this.base.tiChartSeries?.subscribePopupChange(this.id, (open: boolean, event: any) => {
            this.popup = this.wrapper?.querySelector<HTMLElement>('.highcharts-popup:not(.custom-highchart-popup)');

            if (open) {
                if (!this.popup) {
                    return;
                }

                // TraceLoggingHelpers.log('subscribeChartComponentWithHighChartPopup ', event)
                let key = event.annotation?.userOptions?.langKey ?? '';
                if (event.annotation?.userOptions?.isEmoji) {
                    key = 'emoji';
                    $(this.wrapper).find(this.popup).find('span').html('Emoji');
                }

                if (!$(this.wrapper).find(this.popup).parent().hasClass('main-chart')) {
                    $(this.wrapper).find('.ti-chart.normal .main-chart > .highcharts-popup').remove();

                    if (this.popup.classList.contains('login')) { return; }
                    $(this.wrapper).find(this.popup).detach().appendTo(this.wrapper);
                }
                
                setTimeout(() => {
                    this.onHighChartAnnotationToolbarDrag(this.popup);
                    this.onEditButtonClick(event.annotation, key);
                }, 200);
            } else {
                this.editPopupOpen = false;
                this.beforePopupClose();
                this.onPopupClose();
            }
        });
    }

    private onHighChartAnnotationToolbarDrag(popup: HTMLElement) {
        if (!popup || !popup.classList.contains('highcharts-annotation-toolbar') || popup.classList.contains('drag-tracked')) {
            return;
        }

        let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        let dragStart = false;

        popup.addClass('drag-tracked');
        const popupDragEvent = (e: MouseEvent) => {
            const targetElement = e.target as HTMLElement;
            if (dragStart || targetElement.tagName !== 'SPAN') {
                return;
            }

            dragStart = true;

            pos3 = e.clientX;
            pos4 = e.clientY;
        };

        popup.removeEventListener('mousedown', popupDragEvent);
        popup.addEventListener('mousedown', popupDragEvent);

        const mouseMoveEvent = (e: MouseEvent) => {
            if (!dragStart) {
                return;
            }

            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;

            const top = popup.offsetTop - pos2;
            if (top < 40) {
                return;
            }

            popup.style.left = (popup.offsetLeft - pos1) + 'px';
            popup.style.top = (popup.offsetTop - pos2) + 'px';
        };

        document.body.removeEventListener('mousemove', mouseMoveEvent);
        document.body.addEventListener('mousemove', mouseMoveEvent);

        const mouseLeaveEvent = (e: MouseEvent) => {
            if (!dragStart) {
                return;
            }

            dragStart = false;
        };

        document.body.removeEventListener('mouseleave', mouseLeaveEvent);
        document.body.addEventListener('mouseleave', mouseLeaveEvent);

        const mouseUpEvent = (e: MouseEvent) => {
            if (!dragStart) {
                return;
            }

            dragStart = false;
        };

        document.body.removeEventListener('mouseup', mouseUpEvent);
        document.body.addEventListener('mouseup', mouseUpEvent);
    }

    private setEditAnnotationPopupOpenTimer: any;
    private onPopupClose() {
        $(this.wrapper).find('.logo-wrapper').css('z-index', '');
        $(this.wrapper).find('.x-axis-label-wrapper').css('z-index', '');
        
        $(this.wrapper).find('.highcharts-popup').css('overflow', '');
        $(this.wrapper).find('.highcharts-popup .wrapper').remove();
        $(this.wrapper).find('.highcharts-popup-close').show();
        $(this.wrapper).find('.highcharts-popup-main-title').show();
        $(this.wrapper).find('.highcharts-popup-lhs-full').show();
        $(this.wrapper).find('.highcharts-popup-bottom-row').show();

        this.base.tiChartSeries.highChartBuilder.drawingToolRibbonInActive();

        clearTimeout(this.setEditAnnotationPopupOpenTimer);
        this.setEditAnnotationPopupOpenTimer = setTimeout(() => {
            if (this.base.drawingToolsManager) {
                this.base.drawingToolsManager.editAnnotaionPopupOpen = false;
            }        
        }, 1000);
    }

    private beforePopupClose() {
        $(this.popup).find("#backgroundcolorpicker").spectrum('destroy');
        $(this.popup).find("#fontcolorpicker").spectrum('destroy');


        $(".sp-container").remove();
    }

    private highChartEditAnnotation: any = null;
    private openHigChartEditTimers: any;
    private openHighChartsEdit(annotation: any, key: string) {
        $(this.wrapper).find('.logo-wrapper').css('z-index', '-1');
        $(this.wrapper).find('.x-axis-label-wrapper').css('z-index', '-1');

        const htmlTemplate = this.getInputHtmlTemplate(key);
        if (!htmlTemplate) {
            return;
        }

        if (this.base.drawingToolsManager) {
            this.base.drawingToolsManager.editAnnotaionPopupOpen = true;
        }
        
        this.editPopupOpen = true;

        $(this.wrapper).find('.highcharts-popup-close').hide();
        $(this.wrapper).find('.highcharts-popup-main-title').hide();
        $(this.wrapper).find('.highcharts-popup-lhs-full').hide();
        $(this.wrapper).find('.highcharts-popup-bottom-row').hide();

        $(this.wrapper).find('.highcharts-popup .wrapper').remove();
        $(this.wrapper).find('.highcharts-popup').append(htmlTemplate);
        $(this.wrapper).find('.highcharts-popup').css('overflow', 'unset');

        clearTimeout(this.openHigChartEditTimers);
        this.openHigChartEditTimers = setTimeout(() => {
            this.setNewPopupStyleWrapperHeight();

            this.highChartEditAnnotation = annotation;

            if (key == 'label' || key == 'customLabel') {
                this.onTextInputEvents();
            } else if (key == 'emoji') {
                this.onEmojiInputEvents();
            } else if (this.editElliotSegmentsSupportedTypes.some((x: ElliotSegmentModel) => x.name == key)) {
                let elliotSegment = this.editElliotSegmentsSupportedTypes.find((x: ElliotSegmentModel) => x.name == key);
                this.onElliotLabelsSaves(elliotSegment.labelCount);
            } else if (this.editNewPopupSupportedTypes.some((x: string) => x == key)) {
                this.onSegmentLineInputEvents();
            }
        }, 350);
    }

    private setNewPopupStyleWrapperHeight() {
        if (!$(this.wrapper).find('.highcharts-popup .wrapper')?.length) {
            return;
        }

        $(this.wrapper).find('.highcharts-popup .wrapper .content').css('max-height', '');
        $(this.wrapper).find('.highcharts-popup .wrapper .content').css('overflow-y', '');

        setTimeout(() => {
            let popupHeaderFooterHeight = 134;
            if (this.base.marketingWebChartMode) {
                popupHeaderFooterHeight = 0;
            }

            const popupHeight = $(this.wrapper).find('.highcharts-popup').height();
            const contentHeight = popupHeight - popupHeaderFooterHeight;

            $(this.wrapper).find('.highcharts-popup .wrapper .content').css('max-height', contentHeight + 'px');
            $(this.wrapper).find('.highcharts-popup .wrapper .content').css('overflow-y', 'visible');
        }, 50);
    }

    private onEditButtonClick(annotation: any, key: string) {
        this.wrapper?.findFirst('.highcharts-annotation-edit-button')?.ifExistThen((el: HTMLElement) => {
            if (el.containClass('ti-annotation-tracked')) {
                return;
            }

            el.addClass('ti-annotation-tracked');
            el.addEventListener('click', () => {
                this.openHighChartsEdit(annotation, key);
            });
        });
    }

    private setAnnotationStyles() {
        const me = this;
        const highStockChart: any = me.base.tiChartSeries?.highStockChart;
        if (!highStockChart) {
            return;
        }

        const annotations = highStockChart.annotations;
        if (!annotations || !annotations.length) {
            return;
        }

        for (let i = 0; i < annotations.length; i++) {
            const annotation = annotations[i];
            const options = annotation.options;
            if (!options) {
                continue;
            }

            TraceLoggingHelpers.log('setAnnotationStyles options ', options)
           
            if (options.isEmoji) {
                me.base.drawingToolsManager?.updateAnnotationStyles(annotation, options, false);
                annotation.userOptions.labelOptions.style.fontSize = annotation.options.labelOptions.style.fontSize;
                setTimeout(() => {
                        annotation.update({
                            labelOptions: {
                                style: {
                                    fontSize: annotation.options.labelOptions.style.fontSize
                                }
                            },
                            typeOptions: {
                                label: {
                                    text: annotation.options.typeOptions.connector.stroke
                                }
                            }
                        });
                        me.base.drawingToolsManager?.updateAnnotationStyles(annotation, options, true);
                }, 150);
            } else {
                me.base.drawingToolsManager?.updateAnnotationStyles(annotation, options, true);
            }
        }

        if (this.highChartEditAnnotation) {
            me.base.drawingToolsManager?.saveLastSettings(this.highChartEditAnnotation);
        }
        
        me.base.drawingToolsManager?.saveAnnotations();
        highStockChart.redraw();
    }

    private onTextInputEvents() {
        const ctx = this;
        const fontColorPicker = $(this.popup).find('input[highcharts-data-name="labelOptions.style.color"]');
        const backgroundColorPicker = $(this.popup).find('input[highcharts-data-name="labelOptions.backgroundColor"]');
        const text = $(this.popup).find('input[highcharts-data-name="labelOptions.format"]');
        const fontSize = $(this.popup).find('input[highcharts-data-name="labelOptions.style.fontSize"]');

        const initColor: any = $(fontColorPicker).val() == 'contrast' ? '#fff' : $(fontColorPicker).val();
        const extraClassName = this.base.tiChartSeries?.chartStyleSettings?.isDarkTheme ? 'dark' : '';
        $(this.popup).find("#fontcolorpicker").spectrum({
            color: initColor,
            showInput: true,
            showAlpha: true,
            change: (color: any) => {
                //TraceLoggingHelpers.log(color, color._r, color._g, color._b, color._a)
                if (color) {
                    let hex = `rgba(${color._r.toString()},${color._g.toString()},${color._b.toString()},${color._a.toString()})`;
                    //TraceLoggingHelpers.log(hex)
                    $(fontColorPicker).val(hex);
                    $(this.popup).find('.font-color-picker').css('background-color', hex);
                    $(this.popup).find('.font-color-picker').css('background-image', 'unset');
                } else {
                    $(fontColorPicker).val('');
                    $(this.popup).find('.font-color-picker').css('background-color', '');
                    $(this.popup).find('.font-color-picker').css('background-image', '');
                }
            }
        });

        $(this.popup).find('.font-color-picker').css('background-color', initColor);
        $(this.popup).find('.font-color-picker').css('background-image', 'unset');

        $(this.popup).find(".font-color-picker").off('click');
        $(this.popup).find(".font-color-picker").on('click', () => {
            TraceLoggingHelpers.log('click')
            $(this.popup).find("#fontcolorpicker").spectrum('toggle');
            return false;
        });

        $(this.popup).find("#backgroundcolorpicker").spectrum({
            color: $(backgroundColorPicker).val(),
            showInput: true,
            showAlpha: true,
            containerClassName: extraClassName,
            change: (color: any) => {
                if (color) {
                    let hex = `rgba(${color._r.toString()},${color._g.toString()},${color._b.toString()},${color._a.toString()})`;
                    $(backgroundColorPicker).val(hex);
                    $(this.popup).find('.background-color-picker').css('background-color', hex);
                    $(this.popup).find('.background-color-picker').css('background-image', 'unset');
                } else {
                    $(backgroundColorPicker).val('');
                    $(this.popup).find('.background-color-picker').css('background-color', '');
                    $(this.popup).find('.background-color-picker').css('background-image', '');
                }
            }
        });

        $(this.popup).find('.background-color-picker').css('background-color', $(backgroundColorPicker).val() as any);
        $(this.popup).find('.background-color-picker').css('background-image', 'unset');

        $(this.popup).find(".background-color-picker").off('click');
        $(this.popup).find(".background-color-picker").on('click', () => {
            $(this.popup).find("#backgroundcolorpicker").spectrum('toggle');
            return false;
        });

        $(this.popup).find(".font-size-picker-wrapper").off('click');
        $(this.popup).find(".font-size-picker-wrapper").on('click', (e: any) => {
            const hasActive = $(e.currentTarget).hasClass('active');
            ctx.hideAllPickerControls();
            if (!hasActive) {
                // TraceLoggingHelpers.log('active')
                $(e.currentTarget).addClass("active");
            }
        });

        $(this.popup).find(".font-size-picker li").off('click');
        $(this.popup).find(".font-size-picker li").on('click', (e: any) => {
            $(this.popup).find(".font-size-picker li").removeClass('selected');
            $(this.popup).find('.font-size-picker .selected p').html($(e.currentTarget).html());
            $(e.currentTarget).addClass('selected');
            $(fontSize).val($(e.currentTarget).attr('data-value') as any);
        });

        const fontSizeValue = $(this.popup).find('.font-size-picker li[data-value="' + $(fontSize).val() + '"]');
        if (fontSizeValue && fontSizeValue.length) {
            $(this.popup).find(".font-size-picker li").removeClass('selected');
            $(this.popup).find('.font-size-picker .selected p').html($(fontSizeValue).html());
            $(fontSizeValue).addClass('selected');
        }

        $(this.popup).find(".font-style-wrapper").off('click');
        $(this.popup).find(".font-style-wrapper").on('click', (e: any) => {
            const hasActive = $(e.currentTarget).hasClass('active');
            ctx.hideAllPickerControls();
            if (!hasActive) {
                $(e.currentTarget).addClass("active");
            }
        });

        $(this.popup).find('.text-area-wrapper textarea').val($(text).val() as any);

        $(this.popup).find('.text-area-wrapper textarea').trigger('focus');
        $(this.popup).find('.text-area-wrapper textarea').select();
        $(this.popup).find('.text-area-wrapper textarea').on('keyup', () => {
            ctx.validateTextInputSubmitButton();
        });
        $(this.popup).find('.text-area-wrapper textarea').on('change', () => {
            ctx.validateTextInputSubmitButton();
        });

        ctx.validateTextInputSubmitButton();

        $(this.popup).find(".close").off('click');
        $(this.popup).find(".close").on('click', () => {
            ctx.beforePopupClose();
            $(this.popup).find('.highcharts-popup-close').trigger('click');
            ctx.onPopupClose();
        });

        $(this.popup).find(".cancel").off('click');
        $(this.popup).find(".cancel").on('click', () => {
            ctx.beforePopupClose();
            $(this.popup).find('.highcharts-popup-close').trigger('click');
            ctx.onPopupClose();
        });

        $(this.popup).find('.submit').off('click');
        $(this.popup).find('.submit').on('click', () => {
            if ($(this.popup).find('.submit').hasClass('disabled')) {
                return;
            }

            ctx.beforePopupClose();
            $(text).val($(this.popup).find('.text-area-wrapper textarea').val() as any);
            $(this.popup).find('.highcharts-popup-bottom-row button').trigger('click');
            $(this.popup).find('.highcharts-popup-close').show();
            $(this.popup).find('.highcharts-popup-main-title').show();
            $(this.popup).find('.highcharts-popup-lhs-full').show();
            $(this.popup).find('.highcharts-popup-bottom-row').show();

            ctx.setAnnotationStyles();
            ctx.onPopupClose();
        });
    }

    private removeEmojiIfEmpty() {
        const highStockChart: any = this.base.tiChartSeries?.highStockChart;
        if (!highStockChart) {
            return;
        }

        const annotations = highStockChart.annotations;
        if (!annotations || !annotations.length) {
            return;
        }

        // removeAnnotation
        let shouldSaveAnnotations = false;
        for (let i = 0; i < annotations.length; i++) {
            const annotation = annotations[i];
            const options = annotation.options;
            if (!options.isEmoji) {
                continue;
            }

            if (!options || !options.typeOptions?.connector?.stroke || !options.typeOptions?.connector?.stroke?.trim()) {
                shouldSaveAnnotations = true;
                highStockChart.removeAnnotation(annotation);
            }
            // this.base.drawingToolsManager.updateAnnotationStyles(annotation, options, true);
        }

        if (shouldSaveAnnotations) {
            this.base.drawingToolsManager.saveAnnotations();
            highStockChart.redraw();
        }
    }

    private emojiPicker: EmojiPicker | null = null;
    private onEmojiInputEvents() {
        const ctx = this;
        let text = $(this.popup).find('input[highcharts-data-name="typeOptions.connector.stroke"]');
        
        const existingText = ($(text).val() as any).trim();

        if (!EmojiComponent.validEmojiRegex.test(existingText)) {
            $(this.popup).find('.text-area-wrapper textarea').val(``);
        } else {
            $(this.popup).find('.text-area-wrapper textarea').val(existingText);
        }

        $(this.popup).find('.text-area-wrapper textarea').trigger('focus');
        $(this.popup).find('.text-area-wrapper textarea').on('keypress', (event: any) => {
            if (event.keyCode !== 8) {
                event.preventDefault();
            }
        });
        $(this.popup).find('.text-area-wrapper textarea').on('keyup', () => {
            ctx.validateTextInputSubmitButton();
        });
        $(this.popup).find('.text-area-wrapper textarea').on('change', () => {
            ctx.validateTextInputSubmitButton();
        });

        ctx.validateTextInputSubmitButton();

        const emojiContainer = document.querySelector<HTMLElement>('.emoji-picker-container');
        const customEmojis = this.customEmojiData;
        const categories = [
            'smileys-emotion',
            'activities',
            'animals-nature',
            'flags',
            'food-drink',
            'objects',
            'people-body',
            'symbols',
            'travel-places'
        ]

        if (customEmojis.length) {
            categories.unshift('custom');
        }
        
        categories.unshift('recents');

        const dictionary = i18n;
        dictionary.en["categories.custom"] = 'Stock';

        const emojiPickerOptions: any = {
            showRecents: true,
            showVariants: false,
            showPreview: false,
            custom: customEmojis,
            categories: categories as any,
            renderer: new NativeRenderer(),
            locale: 'en',
            i18n: dictionary.en,
            rootElement: emojiContainer
        };

        if (window.matchMedia('(max-width: 360px)').matches) {
            emojiPickerOptions.emojisPerRow = 7;
            emojiPickerOptions.emojiSize = '1rem';
        } else if (window.matchMedia('(max-width: 640px)').matches) {
            emojiPickerOptions.emojisPerRow = 7;
            emojiPickerOptions.emojiSize = '1.2rem';
        } else {
            emojiPickerOptions.emojiSize = '2rem';
        }

        const picker = createPicker(emojiPickerOptions);
        this.emojiPicker = picker;

        const updateCustomEmoji = () => {
            emojiContainer.querySelectorAll('.picmo__emojiCategory').forEach((el: Element, i: number) => {
                if (i < 2) {
                    el.querySelectorAll('button').forEach((b: Element) => {
                        const emoji = b.getAttribute('data-emoji');
                        b.innerHTML = `<span>${emoji}</span>`
                    });
                }
            });
        };

        picker.addEventListener('data:ready', () => {
            TraceLoggingHelpers.log('Picker Ready: ', picker);

            emojiContainer.querySelector<HTMLElement>('.picmo__categoryButton')?.click();
            updateCustomEmoji();


            emojiContainer.querySelectorAll('svg[data-icon="robot"]').forEach((el: Element) => {
                el.setAttribute('viewBox', '0 0 448 512');
                el.innerHTML = '<path d="M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"></path>';
            });
        });

        picker.addEventListener('emoji:select', (selection) => {
            TraceLoggingHelpers.log('Selected emoji: ', selection.emoji);

            setTimeout(() => {
                updateCustomEmoji();
            }, 150)

            const val = $(this.popup).find('.text-area-wrapper textarea').val() + selection.emoji;
            $(this.popup).find('.text-area-wrapper textarea').val(val);
            ctx.validateTextInputSubmitButton();
        });

        $(this.popup).find(".close").off('click');
        $(this.popup).find(".close").on('click', () => {
            ctx.beforePopupClose();
            $(this.popup).find('.highcharts-popup-close').trigger('click');
            ctx.onPopupClose();

            ctx.removeEmojiIfEmpty();
            ctx.emojiPicker = null;
        });

        $(this.popup).find(".cancel").off('click');
        $(this.popup).find(".cancel").on('click', () => {
            ctx.beforePopupClose();
            $(this.popup).find('.highcharts-popup-close').trigger('click');
            ctx.onPopupClose();

            ctx.removeEmojiIfEmpty();
            ctx.emojiPicker = null;
        });

        $(this.popup).find('.submit').off('click');
        $(this.popup).find('.submit').on('click', () => {
            if ($(this.popup).find('.submit').hasClass('disabled')) {
                return;
            }

            ctx.beforePopupClose();
            $(text).val($(this.popup).find('.text-area-wrapper textarea').val() as any);
            $(this.popup).find('.highcharts-popup-bottom-row button').trigger('click');
            $(this.popup).find('.highcharts-popup-close').show();
            $(this.popup).find('.highcharts-popup-main-title').show();
            $(this.popup).find('.highcharts-popup-lhs-full').show();
            $(this.popup).find('.highcharts-popup-bottom-row').show();

            ctx.setAnnotationStyles();
            ctx.onPopupClose();
            ctx.emojiPicker = null;
        });
    }

    private onElliotLabelsSaves(labelCount: number) {
        const ctx = this;
        let backgroundColorPicker = $(this.popup).find('input[highcharts-data-name="typeOptions.line.stroke"]');
        let lineWidth = $(this.popup).find('input[highcharts-data-name="typeOptions.line.strokeWidth"]');

        for (let i = 0; i < labelCount; i++) {
            let currentLabelText = $(this.popup).find(`input[highcharts-data-name="typeOptions.labels.${i}"]`);

            $(this.popup).find(`.text-area-wrapper input[name="labels.${i}"]`).val($(currentLabelText).val() as any);
        }

        const extraClassName = this.base.tiChartSeries?.chartStyleSettings?.isDarkTheme ? 'dark' : '';
        $(this.popup).find("#backgroundcolorpicker").spectrum({
            color: $(backgroundColorPicker).val(),
            showInput: true,
            showAlpha: true,
            containerClassName: extraClassName,
            change: (color: any) => {
                if (color) {
                    let hex = `rgba(${color._r.toString()},${color._g.toString()},${color._b.toString()},${color._a.toString()})`;
                    $(backgroundColorPicker).val(hex);
                    $(this.popup).find('.background-color-picker').css('background-color', hex);
                    $(this.popup).find('.background-color-picker').css('background-image', 'unset');
                } else {
                    $(backgroundColorPicker).val('');
                    $(this.popup).find('.background-color-picker').css('background-color', '');
                    $(this.popup).find('.background-color-picker').css('background-image', '');
                }
            }
        });

        $(this.popup).find('.background-color-picker').css('background-color', $(backgroundColorPicker).val() as any);
        $(this.popup).find('.background-color-picker').css('background-image', 'unset');

        $(this.popup).find(".background-color-picker").off('click');
        $(this.popup).find(".background-color-picker").on('click', () => {
            $(this.popup).find("#backgroundcolorpicker").spectrum('toggle');
            return false;
        });

        $(this.popup).find(".font-size-picker-wrapper").off('click');
        $(this.popup).find(".font-size-picker-wrapper").on('click', (e: any) => {
            const hasActive = $(e.currentTarget).hasClass('active');
            ctx.hideAllPickerControls();
            if (!hasActive) {
                // TraceLoggingHelpers.log('active')
                $(e.currentTarget).addClass("active");
                $(this.popup).find('.highcharts-popup .wrapper .content').css('overflow', 'visible');
            } else {
                $(this.popup).find('.highcharts-popup .wrapper .content').css('overflow', '');
            }
        });

        $(this.popup).find(".font-size-picker li").off('click');
        $(this.popup).find(".font-size-picker li").on('click', (e: any) => {
            $(this.popup).find(".font-size-picker li").removeClass('selected');
            $(this.popup).find('.font-size-picker .selected p').html($(e.currentTarget).html());
            $(e.currentTarget).addClass('selected');
            $(lineWidth).val($(e.currentTarget).attr('data-value') as any);
            $(this.popup).find('.highcharts-popup .wrapper .content').css('overflow', '');
        });

        const fontSizeValue =$(this.popup).find('.font-size-picker li[data-value="' + $(lineWidth).val() + '"]');
        if (fontSizeValue && fontSizeValue.length) {
            $(this.popup).find(".font-size-picker li").removeClass('selected');
            $(this.popup).find('.font-size-picker .selected p').html($(fontSizeValue).html());
            $(fontSizeValue).addClass('selected');
        }

        $(this.popup).find(".close").off('click');
        $(this.popup).find(".close").on('click', () => {
            ctx.beforePopupClose();
            $(this.popup).find('.highcharts-popup-close').trigger('click');
            ctx.onPopupClose();
        });

        $(this.popup).find(".cancel").off('click');
        $(this.popup).find(".cancel").on('click', () => {
            ctx.beforePopupClose();
            $(this.popup).find('.highcharts-popup-close').trigger('click');
            ctx.onPopupClose();
        });

        $(this.popup).find('.submit').removeClass('disabled');
        $(this.popup).find('.submit').off('click');
        $(this.popup).find('.submit').on('click', () => {
            if ($(this.popup).find('.submit').hasClass('disabled')) {
                return;
            }

            ctx.beforePopupClose();

            for (let i = 0; i < labelCount; i++) {
                let currentLabelText = $(this.popup).find(`input[highcharts-data-name="typeOptions.labels.${i}"]`);

                $(currentLabelText).val($(this.popup).find(`.text-area-wrapper input[name="labels.${i}"]`).val() as any);

            }


            $(this.popup).find('.highcharts-popup-bottom-row button').trigger('click');
            $(this.popup).find('.highcharts-popup-close').show();
            $(this.popup).find('.highcharts-popup-main-title').show();
            $(this.popup).find('.highcharts-popup-lhs-full').show();
            $(this.popup).find('.highcharts-popup-bottom-row').show();

            ctx.setAnnotationStyles();
            ctx.onPopupClose();
        });
    }

    private validateTextInputSubmitButton() {
        let valid = true;

        const textAreaValue = $(this.popup).find('.text-area-wrapper textarea').val();
        if (!textAreaValue) {
            valid = false;
        }
        
        const fontSizePickerInput = $(this.popup).find('.font-size-picker-wrapper input');
        if (fontSizePickerInput?.length) {
            const fontSizePickerValue = $(fontSizePickerInput).val();
            if (!fontSizePickerValue) {
                valid = false;
            }
        }

        if (valid) {
            $(this.popup).find('.submit').removeClass('disabled');
        } else {
            $(this.popup).find('.submit').addClass('disabled');
        }
    }

    private onSegmentLineInputEvents() {
        const ctx = this;
        let backgroundColorPicker = $(this.popup).find('input[highcharts-data-name="typeOptions.line.stroke"]');
        let lineWidth = $(this.popup).find('input[highcharts-data-name="typeOptions.line.strokeWidth"]');

        const extraClassName = this.base.tiChartSeries?.chartStyleSettings?.isDarkTheme ? 'dark' : '';
        $(this.popup).find("#backgroundcolorpicker").spectrum({
            color: $(backgroundColorPicker).val(),
            showInput: true,
            showAlpha: true,
            containerClassName: extraClassName,
            change: (color: any) => {
                if (color) {
                    let hex = `rgba(${color._r.toString()},${color._g.toString()},${color._b.toString()},${color._a.toString()})`;
                    $(backgroundColorPicker).val(hex);
                    $(this.popup).find('.background-color-picker').css('background-color', hex);
                    $(this.popup).find('.background-color-picker').css('background-image', 'unset');
                } else {
                    $(backgroundColorPicker).val('');
                    $(this.popup).find('.background-color-picker').css('background-color', '');
                    $(this.popup).find('.background-color-picker').css('background-image', '');
                }
            }
        });

        $(this.popup).find('.background-color-picker').css('background-color', $(backgroundColorPicker).val() as any);
        $(this.popup).find('.background-color-picker').css('background-image', 'unset');

        $(this.popup).find(".background-color-picker").off('click');
        $(this.popup).find(".background-color-picker").on('click', () => {
            $(this.popup).find("#backgroundcolorpicker").spectrum('toggle');
            return false;
        });

        $(this.popup).find(".font-size-picker-wrapper").off('click');
        $(this.popup).find(".font-size-picker-wrapper").on('click', (e: any) => {
            const hasActive = $(e.currentTarget).hasClass('active');
            ctx.hideAllPickerControls();
            if (!hasActive) {
                // TraceLoggingHelpers.log('active')
                $(e.currentTarget).addClass("active");
                $(this.popup).find('.highcharts-popup .wrapper .content').css('overflow', 'visible');
            } else {
                $(this.popup).find('.highcharts-popup .wrapper .content').css('overflow', '');
            }
        });

        $(this.popup).find(".font-size-picker li").off('click');
        $(this.popup).find(".font-size-picker li").on('click', (e: any) => {
            $(this.popup).find(".font-size-picker li").removeClass('selected');
            $(this.popup).find('.font-size-picker .selected p').html($(e.currentTarget).html());
            $(e.currentTarget).addClass('selected');
            $(lineWidth).val($(e.currentTarget).attr('data-value') as any);
            $(this.popup).find('.highcharts-popup .wrapper .content').css('overflow', '');
        });

        const fontSizeValue = $(this.popup).find('.font-size-picker li[data-value="' + $(lineWidth).val() + '"]');
        if (fontSizeValue && fontSizeValue.length) {
            $(this.popup).find(".font-size-picker li").removeClass('selected');
            $(this.popup).find('.font-size-picker .selected p').html($(fontSizeValue).html());
            $(fontSizeValue).addClass('selected');
        }

        $(this.popup).find(".close").off('click');
        $(this.popup).find(".close").on('click', () => {
            ctx.beforePopupClose();
            $(this.popup).find('.highcharts-popup-close').trigger('click');
            ctx.onPopupClose();
        });

        $(this.popup).find(".cancel").off('click');
        $(this.popup).find(".cancel").on('click', () => {
            ctx.beforePopupClose();
            $(this.popup).find('.highcharts-popup-close').trigger('click');
            ctx.onPopupClose();
        });

        $(this.popup).find('.submit').removeClass('disabled');
        $(this.popup).find('.submit').off('click');
        $(this.popup).find('.submit').on('click', () => {
            if ($(this.popup).find('.submit').hasClass('disabled')) {
                return;
            }

            ctx.beforePopupClose();
            $(this.popup).find('.highcharts-popup-bottom-row button').trigger('click');
            $(this.popup).find('.highcharts-popup-close').show();
            $(this.popup).find('.highcharts-popup-main-title').show();
            $(this.popup).find('.highcharts-popup-lhs-full').show();
            $(this.popup).find('.highcharts-popup-bottom-row').show();

            ctx.setAnnotationStyles();
            ctx.onPopupClose();
        });
    }

    private hideAllPickerControls() {
        $(this.popup).find(".font-size-picker-wrapper").removeClass('active');
        $(this.popup).find(".font-style-wrapper").removeClass('active');
    }

    private resizeTimmer = null as any;
    private onResize() {
        this.base.domEvents.onResize(this.id, () => {
            clearTimeout(this.resizeTimmer);
            this.resizeTimmer = setTimeout(() => {
                this.setNewPopupStyleWrapperHeight();
                this.setEmojiSizeAfterResize();
            }, 250);
        });
    }

    private onBodyClick() {
        this.base.domEvents.onScreenClick(this.id, (e: any) => {
            if (!this.editPopupOpen) {
                return;
            }

            if (!$(e.target).parents('.font-size-picker-wrapper').length && !$(e.target).parents('.font-style-wrapper').length) {
                this.hideAllPickerControls();
            }
        });
    }
    
    private setEmojiSizeAfterResize() {
        if (!this.emojiPicker) {
            return;
        }

        let resizeEmojiSize = '2rem';
        if (window.matchMedia('(max-width: 640px)').matches) {
            resizeEmojiSize = '1rem';
        } 

        this.emojiPicker.updateOptions({
            emojiSize: resizeEmojiSize
        })
    }

    private getInputHtmlTemplate(key: string): string {
        if (key == 'label' || key == 'customLabel') {
            return `<div class="wrapper">
                <div class="head">
                    <p class="title"></p>
                    <button class="close" type="button">
                        <span class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="17" height="17"
                                fill="currentColor">
                                <path d="m.58 1.42.82-.82 15 15-.82.82z"></path>
                                <path d="m.58 15.58 15-15 .82.82-15 15z"></path>
                            </svg>
                        </span>
                    </button>
                </div>
                <div class="tabs">
                    <div class="tab active">
                        <p>Text</p>
                    </div>
                </div>
                <div class="content">
                    <div class="control">
                        <div class="sep">
                            <div class="color-picker-wrapper mgr-8">
                                <div class="font-color-picker color-picker" style="background-color: rgb(255, 255, 255); background-image: unset;">
                                    <input id='fontcolorpicker' style="position: relative; top: 20px;height: 1px; width: 1px; visibility: hidden; opacity: 0;" />
                                </div>
                            </div>
                            <div class="font-size-picker-wrapper  mgr-8">
                                <div class="font-size-picker">
                                    <div class="selected">
                                        <p>11</p>
                                    </div>
                                    <div class="arrow">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 7" width="11" height="7"
                                            fill="none">
                                            <path stroke="currentColor" stroke-width="1.3" d="M.5 1.5l5 4 5-4"></path>
                                        </svg>
                                    </div>
                                    <ul class="selection">
                                        <li data-value="10px">10</li>
                                        <li data-value="11px" class="selected">11</li>
                                        <li data-value="12px">12</li>
                                        <li data-value="14px">14</li>
                                        <li data-value="16px">16</li>
                                        <li data-value="20px">20</li>
                                        <li data-value="24px">24</li>
                                    </ul>
                                </div>
                            </div>
                            <!--<div class="font-style-wrapper  font-style-bold mgr-8">
                                <div class="font-style">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28">
                                        <path
                                            d="M14 21h-3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3c2 0 4 1 4 3 0 1 0 2-1.5 3 1.5.5 2.5 2 2.5 4 0 2.75-2.638 4-5 4zM12 9l.004 3c.39.026.82 0 1.25 0C14.908 12 16 11.743 16 10.5c0-1.1-.996-1.5-2.5-1.5-.397 0-.927-.033-1.5 0zm0 5v5h1.5c1.5 0 3.5-.5 3.5-2.5S15 14 13.5 14c-.5 0-.895-.02-1.5 0z">
                                        </path>
                                    </svg>
                                </div>
                            </div>
                            <div class="font-style-wrapper font-style-italic mgr-8">
                                <div class="font-style">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28">
                                        <path
                                            d="M12.143 20l1.714-12H12V7h5v1h-2.143l-1.714 12H15v1h-5v-1h2.143z"></path>
                                    </svg>
                                </div>
                            </div>-->
                        </div>
                    </div>
                    <div class="control">
                        <div class="text-area-wrapper">
                            <textarea name="text" rows="4"></textarea>
                        </div>
                    </div>
                    <div class="control">
                        <span class="label-inline">Background</span>
                        <div class="color-picker-wrapper mgr-8">
                            <div class="background-color-picker color-picker" style="background-color: rgba(0, 0, 0, 0.75); background-image: unset;">
                                <input id='backgroundcolorpicker' style="position: relative; top: 20px;height: 1px; width: 1px; visibility: hidden; opacity: 0;" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <button class="cancel">Cancel</button>
                    <button class="submit disabled">Ok</button>
                </div>
            </div>`;
        } else if (key == 'emoji') {
            return `<div class="wrapper">
                <div class="head">
                    <p class="title"></p>
                    <button class="close" type="button">
                        <span class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="17" height="17"
                                fill="currentColor">
                                <path d="m.58 1.42.82-.82 15 15-.82.82z"></path>
                                <path d="m.58 15.58 15-15 .82.82-15 15z"></path>
                            </svg>
                        </span>
                    </button>
                </div>
                <div class="tabs">
                    <div class="tab active">
                        <p>Emoji</p>
                    </div>
                </div>
                <div class="content">
                    <div class="control">
                        <div class="text-area-wrapper">
                            <textarea name="text" onpaste="return false;" rows="2" style="font-size:24px;"></textarea>
                        </div>
                    </div>
                    <div class="control">
                        <div class="emoji-picker-container"></div>
                    </div>
                </div>
                <div class="footer">
                    <button class="cancel">Cancel</button>
                    <button class="submit disabled">Ok</button>
                </div>
            </div>`;
        } else if (this.editNewPopupSupportedTypes.some((x: string) => x == key)) {
            let title = key == 'curvedLine' ? 'Curved Line' : 'Segment';
            if (key == 'crooked3') {
                title = 'Crooked 3 line';
            }

            let controls = `<div class="control">
        <span class="label-inline" style="margin-right: 46px;">Line Color</span>
        <div class="color-picker-wrapper mgr-8">
            <div class="background-color-picker color-picker" style="background-color: rgba(0, 0, 0, 0.75); background-image: unset;">
                <input id='backgroundcolorpicker' style="position: relative; top: 20px;height: 1px; width: 1px; visibility: hidden; opacity: 0;" />
            </div>
        </div>
    </div>
    <div class="control">
        <span class="label-inline">Line Thickness</span>
        <div class="font-size-picker-wrapper mgr-8">
            <div class="font-size-picker">
                <div class="selected">
                    <p>1</p>
                </div>
                <div class="arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 7" width="11" height="7"
                        fill="none">
                        <path stroke="currentColor" stroke-width="1.3" d="M.5 1.5l5 4 5-4"></path>
                    </svg>
                </div>
                <ul class="selection">
                    <li data-value="1" class="selected">1</li>
                    <li data-value="2">2</li>
                    <li data-value="3">3</li>
                    <li data-value="4">4</li>
                    <li data-value="5">5</li>
                </ul>
            </div>
        </div>
    </div>`;

            if (this.editElliotSegmentsSupportedTypes.some((x: ElliotSegmentModel) => x.name == key)) {
                title = 'Elliot 3 line';

                if (key == 'elliott5') {
                    title = 'Elliot 5 line';
                }

                let elliotSegment = this.editElliotSegmentsSupportedTypes.find((x: ElliotSegmentModel) => x.name == key);
                let elliotLabelCount = elliotSegment.labelCount;
                for (let i = 0; i < elliotLabelCount; i++) {
                    let elliotTextControls =
                        `<div class="control">
                    <span class="label-inline">Label</span>
                    <div class="text-area-wrapper">
                        <input name="labels.${i}" type="text">
                    </div>
                </div>`;

                    controls += elliotTextControls;
                }
            }
            // else if (this.editVerticalSegmentsSupportedTypes.some((x: string) => x == key)) {
            //     controls = `<div class="control">
            //             <span class="label-inline" style="margin-right: 46px;">Font Color</span>
            //             <div class="color-picker-wrapper mgr-8">
            //                 <div class="background-color-picker color-picker" style="background-color: rgba(0, 0, 0, 0.75); background-image: unset;">
            //                     <input id='backgroundcolorpicker' style="position: relative; top: 20px;height: 1px; width: 1px; visibility: hidden; opacity: 0;" />
            //                 </div>
            //             </div>
            //         </div>
            //         <div class="control">
            //             <span class="label-inline">Font Size</span>
            //             <div class="font-size-picker-wrapper mgr-8">
            //                 <div class="font-size-picker">
            //                     <div class="selected">
            //                         <p>1</p>
            //                     </div>
            //                     <div class="arrow">
            //                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 7" width="11" height="7"
            //                             fill="none">
            //                             <path stroke="currentColor" stroke-width="1.3" d="M.5 1.5l5 4 5-4"></path>
            //                         </svg>
            //                     </div>
            //                     <ul class="selection">
            //                         <li data-value="1" class="selected">1</li>
            //                         <li data-value="2">2</li>
            //                         <li data-value="3">3</li>
            //                         <li data-value="4">4</li>
            //                         <li data-value="5">5</li>
            //                     </ul>
            //                 </div>
            //             </div>
            //         </div>`;
            // }

            let headerHtml = `<div class="wrapper">
        <div class="head">
            <p class="title"></p>
            <button class="close" type="button">
                <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="17" height="17"
                        fill="currentColor">
                        <path d="m.58 1.42.82-.82 15 15-.82.82z"></path>
                        <path d="m.58 15.58 15-15 .82.82-15 15z"></path>
                    </svg>
                </span>
            </button>
        </div>
        <div class="tabs">
            <div class="tab active">
                <p>${title}</p>
            </div>
        </div>
        <div class="content">
                ${controls}
        </div>`;

            let footerHtml =
                `<div class="footer">
                    <button class="cancel">Cancel</button>
                    <button class="submit disabled">Ok</button>
                </div>
            </div>`;

            return headerHtml + footerHtml;
        }

        return '';
    }
}

export class ElliotSegmentModel {
    public name = '';
    //public labelCount : number|null;
    public labelCount = 4;

    constructor(name, labelCount) {
        this.name = name;
        this.labelCount = labelCount;
    }
}